<template>
  <div>
    <div v-loading="cptLoading" element-loading-spinner="atom-audit-loader" style="margin-top: 5px;">
      <div v-if="toggleGrid" class="hiaTable level2">
        <table ref="cptGrid" id="cptGrid" class="cpt-table">
          <colgroup v-if="!proReview.isCptLevel2">
            <!-- line sequence -->
            <col class="lineSequenceCol" />
            <!-- code type and original cpt -->
            <col class="codeTypeCol" />
            <!-- original mods -->
            <col class="oneHundredPx" />
            <!-- oridesc -->
            <col class="twentyPercent" />
            <!-- recommended cpt -->
            <col class="oneHundredPx" />
            <!-- recommended mods -->
            <col class="oneHundredPx" />
            <!-- recommended desc -->
            <col class="twentyPercent" />
            <!-- recommended actions -->
            <col class="actionsCol" />
            <!-- reason for change -->
            <col class="reasonForChangeCol" />
          </colgroup>
          <colgroup v-else>
            <!-- line sequence -->
            <col class="lineSequenceCol" />
            <!-- pre cpt code type and pre cpt -->
            <col class="codeTypeCol" />
            <!-- pre cpt mods -->
            <col class="seventyFivePx" />
            <!-- pre cpt desc -->
            <col class="twentyPercent" />
            <!-- original cpt -->
            <col class="oneHundredPx" />
            <!-- original mods -->
            <col class="seventyFivePx" />
            <!-- original desc -->
            <col class="twentyPercent" />
            <!-- pre cpt actions -->
            <col class="preActionsCol" />
            <!-- recommended cpt -->
            <col class="oneHundredPx" />
            <!-- recommended mods -->
            <col class="seventyFivePx" />
            <!-- recommended desc -->
            <col class="twentyPercent" />
            <!-- actions -->
            <col class="actionsCol" />
            <!-- reason for change -->
            <col class="reasonForChangeCol" />
          </colgroup>
          <thead>
            <tr>
              <th class="top-header">#</th>

              <th v-if="!isPivoted" class="top-header">Code Type</th>

              <th v-if="proReview.isCptLevel2" class="leftBorder top-header">
                <div class="codeTypeCol">
                  <hia-el-select :disabled="proReview.isCptLevel2" v-model="preCptCodeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
                </div>
              </th>
              <th class="top-header" v-if="proReview.isCptLevel2">
                Mods
              </th>
              <th v-if="proReview.isCptLevel2" class="top-header">Desc.</th>

              <th class="leftBorder top-header">
                <div class="header-flex-container" style="margin-right: 4px;">
                  <div class="codeTypeCol" v-if="isPivoted">
                    <hia-el-select :disabled="disabled || proReview.isCptLevel2" v-model="originalCptCodeType" @input="handleCodeTypeChange" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
                  </div>
                  <div v-if="!isPivoted">Orig. CPT</div>
                  <i class="el-icon-plus subtle-add-icon" :style="disabled ? 'cursor: not-allowed' : ''" @click="showAddMenu($event)"></i>
                </div>
              </th>
              <th class="top-header">Mods</th>
              <th class="top-header">Desc.</th>
              <th v-if="proReview.isCptLevel2" class="top-header">Actions</th>
              <th class="leftBorder top-header">Rec. CPT</th>
              <th class="top-header">Mods</th>
              <th class="top-header">Desc.</th>
              <th class="top-header">Actions</th>
              <th class="top-header">Reason For Change</th>
            </tr>
            <tr>
              <th class="bottom-header">&nbsp;</th>
              <th v-if="proReview.isCptLevel2" class="leftBorder bottom-header" style="padding-right: 0px;">
                <div class="feeScheduleHeader">
                  <div>Work RVU</div>
                </div>
              </th>
              <th v-if="proReview.isCptLevel2" class="bottom-header" style="padding: 2px 0px 8px 0px;">
                <div class="feeScheduleHeader">
                  <div class="feeScheduleHeaderChild">Global Surgery</div>
                </div>
              </th>
              <th v-if="proReview.isCptLevel2" class="bottom-header" style="padding: 2px 8px 8px 0px;">
                <div style="display: flex;">
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Assistant at Surgery</div>
                  </div>
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Co-Surgeons</div>
                  </div>
                </div>
              </th>
              <th class="leftBorder bottom-header" style="padding-right: 0px;">
                <div class="feeScheduleHeader">
                  <div>Work RVU</div>
                </div>
              </th>
              <th class="bottom-header" style="padding: 2px 0px 8px 0px;">
                <div class="feeScheduleHeader">
                  <div class="feeScheduleHeaderChild">Global Surgery</div>
                </div>
              </th>
              <th class="bottom-header" style="padding: 2px 8px 8px 0px;">
                <div style="display: flex;">
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Assistant at Surgery</div>
                  </div>
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Co-Surgeons</div>
                  </div>
                </div>
              </th>
              <th v-if="proReview.isCptLevel2">&nbsp;</th>
              <th class="leftBorder bottom-header" style="padding-right: 0px;">
                <div class="feeScheduleHeader">
                  <div>Work RVU</div>
                </div>
              </th>
              <th class="bottom-header" style="padding: 2px 0px 8px 0px;">
                <div class="feeScheduleHeader">
                  <div class="feeScheduleHeaderChild">Global Surgery</div>
                </div>
              </th>
              <th class="bottom-header" style="padding: 2px 8px 8px 0px;">
                <div style="display: flex;">
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Assistant at Surgery</div>
                  </div>
                  <div class="feeScheduleHeader">
                    <div class="feeScheduleHeaderChild">Co-Surgeons</div>
                  </div>
                </div>
              </th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in proReview.proRecordCpts" :key="row.cptId" class="cpt-row">
              <td>
                <span class="dragIcon drag-handle" style="margin-top: 3px; float: left">{{ row.lineSequence }}</span>
              </td>

              <td v-if="!isPivoted">
                <hia-el-select v-model="row.codeType" @input="putProRecordCpt(row, 'codeType', $event)" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
              </td>

              <td v-if="proReview.isCptLevel2" class="leftBorder">
                <div class="codeTypeCol">
                  <HiaCodeInput :ref="row.cptId + 'preCpt'" style="width: 112px;" :inputId="`preCpt_${index}`" class="noRightBorder borderLeftRadius" v-model="row.preCpt" :disabled="disabled" @ellipsisClick="emitEllipsisClick(row.preCpt)" @focus="handleCodeInputFocus(row, 'preCpt')" @change="putProRecordCpt(row, 'preCpt', $event)"> </HiaCodeInput>
                </div>
                <span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(row.preEdits)"></span>
                <div style="width: 100%;" class="feeScheduleData" title="Original Work RVU" v-html="getPhysicianFeeScheduleData(row, 'workRvu', 2)"></div>
              </td>

              <td v-if="proReview.isCptLevel2">
                <div style="margin-top: 3px;">
                  <div ref="preCptModifier" v-html="cptModifiers(row.proRecordModifiers, 'preCptModifier')"></div>
                </div>
                <div style="width: 100%;" :title="`Pre-Cpt Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(row, 'globalSurgery', 2))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(row, 'globalSurgery', 2)"></div>
              </td>

              <td v-if="proReview.isCptLevel2">
                <div style="margin-top: 3px;" class="overflow" :id="'PreDesc_' + row.cptId" @click="expandDesc(row.cptId)">{{ row.preCptDescCalc }}</div>
                <div style="display: flex;" class="feeScheduleData">
                  <div :title="`Pre-Cpt Assistant at Surgery\n${getAssistantSurgeryTitle(getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 2))}`" style="flex: 1 1;" v-html="getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 2)"></div>
                  <div :title="`Pre-Cpt Co-Surgeons\n${getCoSurgeonTitle(getPhysicianFeeScheduleData(row, 'coSurgeons', 2))}`" style="flex: 1 1; margin-left: 10px;" v-html="getPhysicianFeeScheduleData(row, 'coSurgeons', 2)"></div>
                </div>
              </td>

              <td class="leftBorder">
                <div class="input-with-icon">
                  <HiaCodeInput :ref="row.cptId + 'origCpt'" style="width: 112px;" :class="{ deleteCode: row.preCptDeleted || (!row.originalCpt && row.deleteCode) }" :placeholder="row.preCpt" :inputId="`originalCpt_${index}`" class="noRightBorder borderLeftRadius" v-model="row.originalCpt" :disabled="disabled || row.preCptDeleted || (!row.originalCpt && row.deleteCode)" @ellipsisClick="emitEllipsisClick(row.originalCpt)" @focus="handleCodeInputFocus(row, 'originalCpt')" @change="putProRecordCpt(row, 'cptCode', $event)"> </HiaCodeInput>
                  <i v-if="proReview.isCptLevel2 && row.originalCpt && !row.preCpt" title="Move Left" class="el-icon-back move-left-icon" @click="moveCodeLeft(row)"></i>
                </div>
                <span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(row.edits)"></span>
                <div style="width: 100%;" class="feeScheduleData" title="Original Work RVU" v-html="getPhysicianFeeScheduleData(row, 'workRvu', 0)"></div>
              </td>

              <td>
                <div style="margin-top: 3px;">
                  <div ref="originalModifier" v-html="cptModifiers(row.proRecordModifiers, 'originalModifier')"></div>
                </div>
                <div style="width: 100%;" :title="`Original Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(row, 'globalSurgery', 0))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(row, 'globalSurgery', 0)"></div>
              </td>

              <td>
                <div style="margin-top: 3px;" class="overflow" :id="'OrDesc_' + row.cptId" @click="expandDesc(row.cptId)">{{ row.preCptDeleted || (!row.originalCpt && row.deleteCode) ? 'Delete Code' : row.originalDescCalc }}</div>
                <div style="display: flex;" class="feeScheduleData">
                  <div :title="`Original Assistant at Surgery\n${getAssistantSurgeryTitle(getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 0))}`" style="flex: 1 1;" v-html="getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 0)"></div>
                  <div :title="`Recommended Co-Surgeons\n${getCoSurgeonTitle(getPhysicianFeeScheduleData(row, 'coSurgeons', 0))}`" style="flex: 1 1; margin-left: 10px;" v-html="getPhysicianFeeScheduleData(row, 'coSurgeons', 0)"></div>
                </div>
              </td>

              <td v-if="proReview.isCptLevel2">
                <div style="margin-top: 5px;" class="preActionsCol">
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.preCptDeleted" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled" @change="putProRecordCpt(row, 'preCptDeleted', $event)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.preCptExclude" :title="`Exclude Changes from ${GET_VALUEFROMKEY('codeTypes', row.preCptCodeType)} Stats`" icon="mdi mdi-alpha-e" :disabled="disabled" @change="putProRecordCpt(row, 'preCptExclude')"> </iconCheckBox>
                </div>
              </td>

              <td class="leftBorder">
                <div>
                  <HiaCodeInput :ref="row.cptId + 'recCpt'" style="width: 112px;" :placeholder="row.originalCpt || row.preCpt" :inputId="`recommendedCpt_${index}`" :class="{ deleteCode: row.deleteCode || (!row.recommendedCpt && row.preCptDeleted) }" v-model="row.recommendedCpt" :disabled="row.deleteCode || disabled" @ellipsisClick="emitEllipsisClick(row.recommendedCpt)" @focus="handleCodeInputFocus(row, 'recommendedCpt')" @change="putProRecordCpt(row, 'cptCode', $event)"> </HiaCodeInput>
                </div>
                <span style="float: left" v-html="cptCodeEdits(row.recEdits)"></span>
                <div style="width: 100%;" title="Recommended Work RVU" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(row, 'workRvu', 1)"></div>
              </td>

              <td>
                <div style="margin-top: 3px;">
                  <div style="margin-top: 3px; display: inline-block" ref="recommendedModifier" v-html="recCptModifers(row.proRecordModifiers, 'originalModifier', 'recommendedModifier')"></div>
                </div>
                <div style="width: 100%;" :title="`Recommended Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(row, 'globalSurgery', 1))}`" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(row, 'globalSurgery', 1)"></div>
              </td>

              <td>
                <div style="margin-top: 3px;" class="overflow" :id="'RecDesc_' + row.cptId" @click="expandDesc(row.cptId)">{{ !row.deleteCode ? row.recDescCalc : 'Delete Code' }}</div>
                <div style="display: flex;" class="feeScheduleData">
                  <div :title="`Recommended Assistant at Surgery\n${getAssistantSurgeryTitle(getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 1))}`" style="flex: 1 1;" v-html="getPhysicianFeeScheduleData(row, 'assistantAtSurgery', 1)"></div>
                  <div :title="`Recommended Co-Surgeons\n${getCoSurgeonTitle(getPhysicianFeeScheduleData(row, 'coSurgeons', 1))}`" style="flex: 1 1; margin-left: 10px;" v-html="getPhysicianFeeScheduleData(row, 'coSurgeons', 1)"></div>
                </div>
              </td>

              <td>
                <div style="margin-top: 5px;">
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.deleteCode" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled" @change="putProRecordCpt(row, 'deleteCpt', $event)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.exclude" :title="`Exclude Changes from ${GET_VALUEFROMKEY('codeTypes', row.codeType)} Stats`" icon="mdi mdi-alpha-e" :disabled="disabled" @change="putProRecordCpt(row)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.validated" title="Validated by Reviewer" icon="mdi mdi-alpha-v" :disabled="disabled" @change="putProRecordCpt(row)"> </iconCheckBox>
                  <i class="mdi mdi-alpha-m" @click="openModModal(row)" style="cursor: pointer; float: left; font-size: 20px; color: grey;" title="Edit Modifiers"></i>
                </div>
              </td>

              <td>
                <hia-el-select style="width: 82%" :title="disableReasonForChange(row) ? 'No change on line' : null" :disabled="disableReasonForChange(row) || disabled" @input="putProRecordCpt(row, $event)" v-model="row.reasonForChange" placeholder="Reason for Change" itemkey="key" label="value" :dropdowns="dropdowns.proReasonsForChangeCpt.list" clearable filterable> </hia-el-select>
                <i v-if="!disabled" style="float: right; cursor: pointer; margin-top: -20px;" title="Delete CPT Row" class="el-icon-close delete-button" @click="deleteCpt(row)"></i>
              </td>
            </tr>

            <!-- Special Add Row -->
            <tr class="add-row" key="addRow">
              <td>
                &nbsp;
              </td>

              <td v-show="!isPivoted">
                <hia-el-select key="addRowCodeType" v-model="addRow.codeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
              </td>

              <td v-show="proReview.isCptLevel2">
                <input key="addRowPreCpt" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="cptLoading" id="preCpt" maxlength="7" minlength="3" v-model="addRow.preCpt" v-on:keyup.enter="addCptRow(addRow)" />
              </td>
              <td v-show="proReview.isCptLevel2">
                &nbsp;
              </td>
              <td v-show="proReview.isCptLevel2">
                &nbsp;
              </td>

              <td>
                <input key="addRowOriginalCpt" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="cptLoading" id="originalCpt" maxlength="7" minlength="3" v-model="addRow.originalCpt" v-on:keyup.enter="addCptRow(addRow)" />
              </td>
              <td colspan="2">
                <el-select :disabled="disabled" style="max-width: 80px" class="addMultiModifiers" @input="setMultiMods(addRow, 'originalModifiers', 'Recommended', 'recommendedModifiers', $event)" v-model="addRow.originalModifiers" filterable multiple clearable placeholder="Multiple Mods">
                  <el-option v-for="item in dropdowns.modifiers.list" :key="item.key" :label="item.key" :value="item.key" :title="item.value"> </el-option>
                </el-select>
              </td>

              <td v-show="proReview.isCptLevel2">
                <div>&nbsp;</div>
              </td>

              <td>
                <input key="addRowRecommendedCpt" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="cptLoading" id="recommendedCpt" maxlength="7" minlength="3" v-model="addRow.recommendedCpt" v-on:keyup.enter="addCptRow(addRow)" />
              </td>
              <td colspan="2">
                <el-select :disabled="disabled" style="max-width: 80px" class="addMultiModifiers" @input="setMultiMods(addRow, 'recommendedModifiers', 'Original', 'originalModifiers', $event)" v-model="addRow.recommendedModifiers" filterable multiple clearable placeholder="Multiple Mods">
                  <el-option v-for="item in dropdowns.modifiers.list" :key="item.key" :label="item.key" :value="item.key" :title="item.value"> </el-option>
                </el-select>
              </td>
              <td>
                <div>&nbsp;</div>
              </td>
              <td>
                <el-popover ref="addPopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="addPopoverContent" v-model="showAddPopover" @after-enter="handleHidePopOver('addPopover')">
                  <el-button key="addRowAddButton" :disabled="disabled" round slot="reference" style="float: right;" icon="el-icon-plus" type="primary" size="mini" @click="addCptRow(addRow)">Add </el-button>
                </el-popover>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="dialogs">
      <addMultipleCodes :disabled="disabled" :defaultCodeType="proReview.project.defaultCodeType" :codeTypeRequired="true" :show="showAddMultipleCodes" :type="'CPT'" :review="proReview" @close="handleCloseAddMultipleCodes" @postAddMultipleCodes="postAddMultipleCodes"> </addMultipleCodes>
    </div>

    <el-dialog
      v-if="modModalCpt !== null"
      class="modDialog"
      :visible="showModModal"
      :title="`Edit Modifiers for CPT Line ${modModalCpt.lineSequence}`"
      width="80%"
      :before-close="
        () => {
          showModModal = false
        }
      "
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form size="mini" label-position="left" label-width="140px">
        <el-row style="margin-bottom: 20px;">
          <el-col :span="12">
            <el-form-item label="Original Cpt">
              <div style="width: 100%;">
                <el-input style="width: 112px; display: inline-block;" inputId="originalCptMod" :value="modModalCpt.originalCpt || modModalCpt.preCpt" disabled> </el-input>
                <span style=" margin-left: 5px; margin-top: 3px; display: inline-block" ref="originalModifier" v-html="cptModifiers(modModalCpt.proRecordModifiers, 'originalModifier')"> </span>
              </div>
              <div>
                <div style="margin: 3px 5px 0px 0px; display: inline-block"><span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(modModalCpt.edits)"></span></div>
                <div style="margin-top: 3px; display: inline-block" class="overflow" :id="'OrDesc_Mod_' + modModalCpt.cptId" @click="expandDesc(modModalCpt.cptId, true)">{{ modModalCpt.originalDescCalc }}</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Recommended Cpt">
              <div style="width: 100%;">
                <el-input style="width: 112px; display: inline-block;" :placeholder="modModalCpt.originalCpt || modModalCpt.preCpt" inputId="recCptMod" v-model="modModalCpt.recommendedCpt" disabled :class="{ deleteCode: modModalCpt.level2DeleteCode || modModalCpt.deleteCode }"> </el-input>
                <span style="margin-left: 5px; margin-top: 3px; display: inline-block" ref="originalModifier" v-html="recCptModifers(modModalCpt.proRecordModifiers, 'originalModifier', 'recommendedModifier')"> </span>
              </div>
              <div style="margin: 3px 5px 0px 0px; display: inline-block"><span style="float: left; margin-top: 1px;" v-html="cptCodeEdits(modModalCpt.recEdits)"></span></div>
              <div style="margin-top: 3px; display: inline-block" class="overflow" :id="'RecDesc_Mod_' + modModalCpt.cptId" @click="expandDesc(modModalCpt.cptId, true)">{{ !modModalCpt.deleteCode ? modModalCpt.recDescCalc : 'Delete Code' }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row>
        <el-col :span="12">
          <h4 class="headerWithBorder">Original Modifiers</h4>
        </el-col>
        <el-col :span="12">
          <h4 class="headerWithBorder">Recommended Modifiers</h4>
        </el-col>
      </el-row>
      <proReviewModifiers :cpt="modModalCpt"> </proReviewModifiers>

      <span slot="footer">
        <el-button @click="showModModal = false" size="mini" type="text" plain round>Close</el-button>
      </span>
    </el-dialog>

    <el-popover ref="savePopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" @after-enter="handleHidePopOver('savePopover')"> </el-popover>

    <!-- Context Menu for Add Left/Right -->
    <div v-if="showContextMenu" class="context-menu" :style="contextMenuStyle" @click.stop>
      <template v-if="!proReview.isCptLevel2 && isPivoted">
        <template v-if="originalCptCodeType">
          <div v-for="codeType in moveLeftCodeTypes" :key="codeType.key" class="context-menu-item" @click="copyLeft(codeType)">
            <i class="el-icon-arrow-left"></i>
            Add Left {{ codeType.value }}
          </div>
        </template>
        <template v-else>
          <div class="context-menu-item" style="cursor: not-allowed;">
            <i class="el-icon-warning" style="color: red;"></i>
            Choose Code Type to Add Left
          </div>
        </template>
      </template>
      <div v-if="proReview.isCptLevel2" class="context-menu-item" @click="removeLeft">
        <i class="el-icon-remove-outline"></i>
        Remove Left
      </div>
      <div v-if="isPivoted && !proReview.isCptLevel2" class="context-menu-item" @click="unPivot">
        <i class="el-icon-refresh"></i>
        Un-pivot Code Types
      </div>
      <div v-if="!isPivoted" class="context-menu-item" @click="pivot">
        <i class="el-icon-refresh"></i>
        Pivot Code Types
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
  import iconCheckBox from '@/components/controls/iconCheckBox'
  import HiaCodeInput from '@/components/controls/HiaCodeInput'
  import Sortable from 'sortablejs'
  import addMultipleCodes from '@/components/controls/addMultipleCodes'
  import proReviewModifiers from './proReviewModifiers'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'proReviewCptsPivot',
    props: ['showAddMultipleCodes'],
    mixins: [HiaAuthorization],
    data: function() {
      return {
        activeRowBackup: {},
        toggleGrid: true,
        isPivoted: true,
        theSortable: null,
        localOriginalCptCodeType: '',
        localPreCptCodeType: '',
        addPopoverContent: '',
        savePopoverContent: '',
        showAddPopover: false,
        showContextMenu: false,
        showModModal: false,
        modModalCpt: null,
        contextMenuStyle: {
          position: 'fixed',
          top: '0px',
          left: '0px'
        },
        addRow: { codeType: '', originalCpt: '', recommendedCpt: '', preCpt: '', originalModifiers: [], recommendedModifiers: [] }
      }
    },
    components: {
      iconCheckBox,
      HiaCodeInput,
      addMultipleCodes,
      proReviewModifiers
    },
    methods: {
      ...mapActions('proReviews/', ['PUT_PRO_CPT', 'DELETE_PRO_CPT', 'POST_PRO_CPT', 'PUT_PRO_CPTS_FOR_RESEQUENCE', 'PUT_PRO_CPT_CHILD', 'COPY_PRO_CPT_LEFT', 'POST_PRO_CPT_CHILD', 'PUT_PRO_CPT_MASS_UPDATE']),
      ...mapMutations('proReviews/', ['SET_PRO_CPT_ROW', 'PUSH_CPT_ROW', 'SET_PRO_CPTS']),
      shouldConfirmReasonClear(row) {
        if (!row || !row.reasonForChange) {
          return false
        }
        const noRecommendations = !row.recommendedCpt && !row.deleteCode && !row.newPrimary
        if (!noRecommendations) {
          return false
        }
        if (this.proReview && this.proReview.isCptLevel2) {
          return !row.originalCpt && !row.preCptDeleted && !row.preCptNewPrimary
        }
        return true
      },
      handleCodeInputFocus(row, prop) {
        this.backupRow(row)
        this.emitFocusedCode(row[prop])
      },
      backupRow(row) {
        this.activeRowBackup = { ...row }
      },
      async putProRecordCpt(row, changedField, e) {
        if (!row.recommendedCpt && !row.originalCpt && !row.preCpt) {
          let message = 'Either the  Original CPT or Recommended CPT must be populated. To delete the entire row, use the X button on the right side.'
          if (this.proReview.isCptLevel2) {
            message = `Either the ${this.GET_VALUEFROMKEY('codeTypes', row.preCptCodeType)} CPT, ${this.GET_VALUEFROMKEY('codeTypes', row.codeType)} CPT or Recommended CPT must be populated. To delete the entire row, use the X button on the right side.`
          }
          this.savePopoverContent = message
          this.openSavePopover(e)
          this.SET_PRO_CPT_ROW(this.activeRowBackup)
          return
        }

        if (!(row.originalCpt || row.preCpt) && changedField === 'deleteCpt') {
          row.deleteCode = false
          this.savePopoverContent = 'The Delete Code recommendation cannot be used if there is no code in the Original CPT Position.'
          this.openSavePopover(e)
          return
        }

        if (!row.preCpt && changedField === 'preCptDeleted') {
          row.preCptDeleted = false
          this.savePopoverContent = `The Delete Code recommendation cannot be used if there is no code in the ${this.GET_VALUEFROMKEY('codeTypes', row.preCptCodeType)} Position.`
          this.openSavePopover(e)
          return
        }

        if (this.shouldConfirmReasonClear(row)) {
          try {
            await this.$confirm('This will clear the Reason for Change. Continue?', 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.reasonForChange = null
          } catch (e) {
            this.SET_PRO_CPT_ROW(this.activeRowBackup)
            return
          }
        }

        if (changedField === 'deleteCpt' && row.recommendedCpt && row.deleteCode) {
          try {
            await this.$confirm(`This will clear the Recommended CPT ${row.recommendedCpt}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.recommendedCpt = null
          } catch (e) {
            this.SET_PRO_CPT_ROW(this.activeRowBackup)
            return
          }
        }

        if (changedField === 'preCptDeleted' && row.originalCpt && row.preCptDeleted) {
          try {
            await this.$confirm(`This will clear the ${this.GET_VALUEFROMKEY('codeTypes', row.codeType)} ${row.originalCpt}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.originalCpt = null
          } catch (e) {
            this.SET_PRO_CPT_ROW(this.activeRowBackup)
            return
          }
        }

        const payload = { cptRow: row, changedField: changedField }

        try {
          await this.PUT_PRO_CPT(payload)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Update Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'CPT Code Update Error',
            type: 'error'
          })
        }
      },
      async handleCodeTypeChange(e) {
        if (this.proReview.proRecordCpts.length === 0) {
          return
        }
        try {
          await this.PUT_PRO_CPT_MASS_UPDATE(this.proReview.proRecordCpts)
          this.$message({
            message: 'CPT Code Update Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'CPT Code Update Error',
            type: 'error'
          })
        }
      },
      moveCodeLeft(row) {
        row.preCpt = row.originalCpt
        row.originalCpt = null
        this.putProRecordCpt(row, 'originalCpt')
      },
      showAddMenu(event) {
        if (this.disabled) {
          return
        }
        event.preventDefault()
        event.stopPropagation()

        this.contextMenuStyle = {
          position: 'fixed',
          top: event.clientY + 'px',
          left: event.clientX + 'px'
        }
        this.showContextMenu = true

        // Close menu when clicking outside
        const closeMenu = e => {
          // Check if click is outside the context menu and not on the trigger element
          const contextMenu = this.$el.querySelector('.context-menu')
          const triggerElement = e.target.closest('.subtle-add-icon')

          if (contextMenu && !contextMenu.contains(e.target) && !triggerElement) {
            this.showContextMenu = false
            document.removeEventListener('click', closeMenu)
          }
        }
        document.addEventListener('click', closeMenu)
      },
      async copyLeft(codeType) {
        this.showContextMenu = false
        if (this.proReview.proRecordCpts.length > 0) {
          try {
            const payload = {
              proRecordId: this.proReview.proRecordId,
              middleCodeType: this.originalCptCodeType,
              codeType: codeType.key
            }
            await this.COPY_PRO_CPT_LEFT(payload)
          } catch (e) {
            this.$message({
              message: 'Copy Left Code Update Error',
              type: 'error'
            })
          }
        } else {
          this.proReview.isCptLevel2 = true
          this.localPreCptCodeType = codeType.key
        }
      },
      async removeLeft() {
        this.showContextMenu = false
        if (this.proReview.proRecordCpts.length > 0) {
          try {
            const payload = {
              proRecordId: this.proReview.proRecordId,
              middleCodeType: this.originalCptCodeType,
              codeType: null
            }
            await this.COPY_PRO_CPT_LEFT(payload)
          } catch (e) {
            this.$message({
              message: 'Copy Left Code Update Error',
              type: 'error'
            })
          }
        } else {
          this.proReview.isCptLevel2 = false
          this.localPreCptCodeType = ''
        }
      },
      unPivot() {
        this.showContextMenu = false
        this.isPivoted = false
        this.proReview.isCptLevel2 = false
      },
      pivot() {
        this.showContextMenu = false
        this.isPivoted = true
        this.proReview.isCptLevel2 = false
      },
      setAddRow(row) {
        this.addRow = { ...row }
      },
      disableReasonForChange(row) {
        // Check if there are any recommended changes
        const hasRecommendedChanges = row.recommendedCpt || row.newPrimary || row.deleteCode

        // Check if there are any preCpt changes (only relevant in Level 2)
        const hasPreCptChanges = this.proReview.isCptLevel2 && (row.originalCpt || row.preCptDeleted || row.preCptNewPrimary || row.preCptExclude)

        // Disable only if there are no changes at all
        return !hasRecommendedChanges && !hasPreCptChanges
      },

      async addCptRow(row) {
        row.codeType = row.codeType || this.proReview.project.defaultCodeType || this.originalCptCodeType

        if (this.proReview.isCptLevel2 && !row.preCpt && !row.originalCpt && !row.recommendedCpt) {
          this.addPopoverContent = `Either ${this.GET_VALUEFROMKEY('codeTypes', this.preCptCodeType)} CPT, ${this.GET_VALUEFROMKEY('codeTypes', this.originalCptCodeType)} CPT or Recommended CPT must be populated to add row.`
          this.showAddPopover = true
          return
        }

        if (!this.proReview.isCptLevel2 && !row.codeType && !row.originalCpt && !row.recommendedCpt) {
          this.addPopoverContent = 'Code Type and either Original CPT or Recommended CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (!this.proReview.isCptLevel2 && !row.originalCpt && !row.recommendedCpt) {
          this.addPopoverContent = 'Either Original CPT or Recommended CPT must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (this.proReview.isCptLevel2) {
          this.addRow.codeType = this.originalCptCodeType || this.proReview.project.defaultCodeType
        }

        if (!row.codeType) {
          this.addPopoverContent = 'Code Type must be populated to add row.'
          this.showAddPopover = true
          return
        }

        row.cptId = 0
        row.proRecordId = this.proReview.proRecordId
        row.newPrimary = false
        row.originalCpt = row.originalCpt
          ? row.originalCpt
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null
        row.recommendedCpt = row.recommendedCpt
          ? row.recommendedCpt
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null

        if (this.proReview.isCptLevel2) {
          row.preCpt = row.preCpt
            ? row.preCpt
                .toUpperCase()
                .replace('.', '')
                .trim()
            : null
          row.preCptCodeType = this.preCptCodeType
        }

        try {
          await this.POST_PRO_CPT([row])
          this.addRow = { codeType: row.codeType, originalCpt: '', recommendedCpt: '', preCpt: '' }
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Added Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'CPT Code Add Error',
            type: 'error'
          })
        }
      },
      async deleteCpt(row) {
        try {
          await this.DELETE_PRO_CPT(row)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Deleted Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'CPT Code Delete Error',
            type: 'error'
          })
        }
      },
      openSavePopover(e) {
        if (!e) {
          return
        }

        const popper = this.$refs.savePopover

        popper.doDestroy()
        popper.doClose()

        this.$nextTick(() => {
          this.popperClickTarget = e.target
          popper.doDestroy()
          popper.referenceElm = this.popperClickTarget
          this.isOpen = true
          popper.doShow()
        })
      },
      handleHidePopOver(ref) {
        const popper = this.$refs[ref]
        const handler = e => {
          if (e.target !== popper.$el) {
            popper.doDestroy()
            popper.doClose()
          }
          document.removeEventListener('click', handler, false)
        }
        document.addEventListener('click', handler, false)
      },
      emitEllipsisClick(code) {
        this.emitFocusedCode(code)
        this.$emit('ellipsisClick', code)
      },
      emitFocusedCode(focusedCode) {
        if (focusedCode && focusedCode !== 'DEL') {
          const truCodeQueryObject = {
            code: focusedCode,
            type: 'CPT'
          }
          this.$emit('onCodeFocus', truCodeQueryObject)
        }
      },
      cptCodeEdits(edits) {
        if (edits && edits.length) {
          let cptDesc = ''
          for (const i in edits) {
            cptDesc += edits[i].description.replace(/<[^>]*>/g, '') + ' \n'
          }
          return '<div style="background: url(/static/trucode/css/img/icons/warning.png); width: 16px; height: 16px; margin-top: 2px"  title="' + cptDesc.trim() + '"></div>'
        }
        return ''
      },
      cptCodeHccs: function(hccs) {
        if (hccs && hccs.length) {
          const copy = JSON.parse(JSON.stringify(hccs))
          const sortByVersionThenValue = (a, b) => {
            if (a.version !== b.version) {
              return a.version - b.version
            }
            return a.value - b.value
          }

          copy.sort(sortByVersionThenValue)

          let html = ''
          for (let i = 0; i < copy.length; i++) {
            const title = copy[i].description
            const value = copy[i].value
            const version = copy[i].version
            if (version) {
              html += `<span class="hcc hcc${version}" title="V${version} - ${title}">${value}</span>`
            } else {
              html += `<span class="hcc" title="${title}">${value}</span>`
            }
          }
          return html
        }
        return '<div>&nbsp;</div>'
      },
      async handleDragStop(e) {
        const temp = this.proReview.proRecordCpts[e.oldIndex]
        this.proReview.proRecordCpts.splice(e.oldIndex, 1)
        this.proReview.proRecordCpts.splice(e.newIndex, 0, temp)
        this.updateLineSequence(this.proReview.proRecordCpts)
        this.SET_PRO_CPTS(this.proReview.proRecordCpts)

        // force the grid to re-initialize by destroying and recreating it
        // and then reattaching the sortable
        this.toggleGrid = false
        this.theSortable.destroy()
        this.$nextTick(() => {
          this.toggleGrid = true
          this.$nextTick(() => {
            this.attachSortable()
          })
        })

        try {
          await this.PUT_PRO_CPTS_FOR_RESEQUENCE(this.proReview.proRecordCpts)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'CPT Code Updated Successfully',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'CPT Code Update Error',
            type: 'error'
          })
        }
      },
      updateLineSequence(array) {
        array.map((o, i) => {
          o.lineSequence = i + 1
          return o
        })
      },
      attachSortable() {
        const gridElementName = 'cptGrid'
        const gridDiv = document.getElementById(gridElementName)
        if (gridDiv) {
          const tbody = gridDiv.getElementsByTagName('tbody')
          if (tbody[0]) {
            this.theSortable = Sortable.create(tbody[0], {
              animation: 200,
              draggable: 'tr',
              handle: '.drag-handle',
              onEnd: e => {
                this.handleDragStop(e)
              }
            })
          }
        }
      },
      handleCloseAddMultipleCodes() {
        this.$emit('handleCloseAddMultipleCodes', false)
      },
      async postAddMultipleCodes(data) {
        if (data.codes) {
          // populate new CPT codes
          const newCodes = []
          let startLineSequence = this.proReview.proRecordCpts.length + 1
          data.codes.forEach((v, i) => {
            const newCptCode = {
              proRecordId: this.proReview.proRecordId,
              lineSequence: startLineSequence,
              add: true,
              originalCpt: data.isRecommended ? null : v.trim(),
              exclude: false,
              validated: false,
              recommendedCpt: data.isRecommended ? v.trim() : null,
              newPrimary: false,
              reasonForChange: '',
              codeType: data.codeType
            }
            newCodes.push(newCptCode)
            startLineSequence++
          })
          data.codes = newCodes
          data.changedField = 'addMultipleCodes'
          try {
            await this.POST_PRO_CPT(data.codes)
            this.$message({
              message: 'Multiple Codes Added Successfully',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              message: 'Multiple Codes Added Error',
              type: 'error'
            })
          }
        }
      },
      openModModal(row) {
        this.modModalCpt = this.proReview.proRecordCpts.find(x => x.cptId === row.cptId)
        this.showModModal = true
      },
      async setMultiMods(row, sourceProp, targetProp, targetModifierProp, event) {
        // handle clear logic for original vs recommended
        if (row[targetModifierProp] && row[targetModifierProp].length) {
          try {
            await this.$confirm(`This will clear the ${targetProp} Modifiers. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row[targetModifierProp] = []
            this.setAddRow(row)
          } catch (e) {
            row[sourceProp] = []
            this.setAddRow(row)
          }
        } else {
          this.setAddRow(row)
        }
      },
      recCptModifers(modifiers, originalModifier, recommendedModifier) {
        if (modifiers && modifiers.length) {
          let modifierList = []
          modifiers.forEach((v, i) => {
            const row = v
            row.displayMod = v[recommendedModifier] || v[originalModifier]
            modifierList.push(row)
          })
          modifierList = modifierList.filter(function(n) {
            if (n.displayMod !== undefined && n.displayMod !== null) {
              return true
            }
            return false
          })
          if (modifierList !== null) {
            const modLength = modifierList.length
            let modifer = ''
            let comma = ''
            if (modLength) {
              for (let i = 0; i < modLength; i++) {
                if (modifierList[i].displayMod !== null && modifierList[i].displayMod.trim().length > 1) {
                  comma = modLength > 1 && i + 1 !== modLength ? ',' : ''
                  modifer += `<span id="recommendedModifier_${i}" ${modifierList[i].deleteCode ? 'class="strikethrough"' : null} title="${this.modDescription(modifierList[i].displayMod, modifierList[i].deleteCode)}">${modifierList[i].displayMod}</span>${comma}`
                }
              }
            }
            return modifer
          }
        }
        return null
      },
      cptModifiers(modifiers, version) {
        // remove blank mods
        modifiers = modifiers.filter(function(n) {
          if (n[version] !== undefined && n[version] !== null) {
            return true
          }
          return false
        })
        if (modifiers !== null) {
          const modLength = modifiers.length
          let modifer = ''
          let comma = ''
          if (modLength) {
            const cptId = modifiers[0].cptid
            for (let i = 0; i < modLength; i++) {
              if (modifiers[i][version] !== null && modifiers[i][version].trim().length > 1) {
                comma = modLength > 1 && i + 1 !== modLength ? ',' : ''
                modifer += '<span id="' + version + '_' + i + '" cptId="' + cptId + '" title="' + this.modDescription(modifiers[i][version]) + '">' + modifiers[i][version] + '</span>' + comma
              }
            }
          }
          return modifer
        }
        return null
      },
      modDescription(modifier, deleteCode = false) {
        if (deleteCode) {
          return 'Delete Modifier'
        }

        if (modifier !== null && modifier.length) {
          let desc = ''
          for (const i in this.dropdowns.modifiers.list) {
            if (modifier === this.dropdowns.modifiers.list[i].key) {
              desc = this.dropdowns.modifiers.list[i].value
                .split('|')[1]
                .trim()
                .toLowerCase()
              break
            }
          }
          return desc
        }
      },
      getPhysicianFeeScheduleData(cpt, field, level) {
        let data = null
        switch (level) {
          case 0:
            data = cpt.originalCpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
          case 1:
            data = cpt.recommendedCpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
          case 2:
            data = cpt.preCpt ? this.proReview.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level) : null
            break
        }
        return data ? data[field] : '&nbsp;'
      },
      getGlobalSurgeryTitle(val) {
        const map = {
          '000': '000 - Endoscopic or minor procedure with related preoperative and postoperative relative values on the day of the procedure only included in the fee schedule payment amount; evaluation and management services on the day of the procedure generally not payable.',
          '010': '010 - Minor procedure with preoperative relative values on the day of the procedure and postoperative relative values during a 10 day postoperative period included in the fee schedule amount; evaluation and management services on the day of the procedure and during the 10-day postoperative period generally not payable.',
          '090': '090 - Major surgery with a 1-day preoperative period and 90-day postoperative period included in the fee schedule amount.',
          MMM: 'MMM - Maternity codes; usual global period does not apply.',
          XXX: 'XXX - The global concept does not apply to the code.',
          YYY: 'YYY - The carrier is to determine whether the global concept applies and establishes postoperative period, if appropriate, at time of pricing.',
          ZZZ: 'ZZZ - The code is related to another service and is always included in the global period of the other service.'
        }
        return map[val]
      },
      getCoSurgeonTitle(val) {
        const map = {
          0: '0 - Co-surgeons not permitted for this procedure.',
          1: '1 - Co-surgeons could be paid. Supporting documentation is required to establish medical necessity of 2 surgeons for the procedure.',
          2: '2 - Co-surgeons permitted. No documentation is required if 2 specialty requirements are met.',
          9: '9 - Concept does not apply.'
        }
        return map[val]
      },
      getAssistantSurgeryTitle(val) {
        const map = {
          0: '0 - Payment restriction for assistants at surgery applies to this procedure unless supporting documentation is submitted to establish medical necessity.',
          1: '1 - Statutory payment restriction for assistants at surgery applies to this procedure. Assistants at surgery may not be paid.',
          2: '2 - Payment restriction for assistants at surgery does not apply to this procedure. Assistants at surgery may be paid.',
          9: '9 - Concept does not apply.'
        }
        return map[val]
      },
      buildModifiers(modifiers, version, codeType) {
        // populate new mods
        const newMods = []
        let startLineSequence = 1
        modifiers.forEach((v, i) => {
          const newMod = {
            lineSequence: startLineSequence,
            [version]: v ? v.trim() : null,
            codeType: codeType
          }
          newMods.push(newMod)
          startLineSequence++
        })

        return newMods
      },
      expandDesc(cptId, isMod = false) {
        const orTargetId = isMod ? 'OrDesc_Mod_' + cptId : 'OrDesc_' + cptId
        const recTargetId = isMod ? 'RecDesc_Mod_' + cptId : 'RecDesc_' + cptId
        const preTargetId = isMod ? 'PreDesc_Mod_' + cptId : 'PreDesc_' + cptId

        const orEl = document.getElementById(orTargetId)
        const recEl = document.getElementById(recTargetId)
        const preEl = document.getElementById(preTargetId)

        orEl.classList.toggle('overflow')
        recEl.classList.toggle('overflow')
        preEl.classList.toggle('overflow')
      }
    },
    mounted: function() {
      const uniqueCodeTypes = [...new Set(this.proReview.proRecordCpts.map(cpt => cpt.codeType))]

      if (uniqueCodeTypes.length > 1) {
        this.isPivoted = false
      }

      this.addRow.codeType = this.originalCptCodeType

      this.$nextTick(() => {
        this.attachSortable()
      })
    },
    watch: {
      'proReview.project.defaultCodeType': function(val) {
        if (this.proReview.project) {
          this.addRow = { codeType: this.proReview.project.defaultCodeType, originalCpt: '', recommendedCpt: '' }
        }
      }
    },
    computed: {
      ...mapGetters('dropdowns/', ['GET_VALUEFROMKEY']),
      ...mapState('proReviews/', ['proReview', 'cptLoading']),
      ...mapState('dropdowns/', ['dropdowns']),
      disabled() {
        return !!this.readOnly() || this.proReview.reviewStatusId !== 2
      },
      moveLeftCodeTypes() {
        return this.dropdowns.codeTypes.list.filter(ct => ct.key !== this.originalCptCodeType)
      },
      originalCptCodeType: {
        get() {
          return this.proReview.proRecordCpts[0]?.codeType || this.proReview.project.defaultCodeType || this.localOriginalCptCodeType
        },
        set(value) {
          this.addRow.codeType = value
          if (this.proReview.proRecordCpts.length > 0) {
            this.proReview.proRecordCpts.forEach(cpt => {
              cpt.codeType = value
            })
          } else {
            this.localOriginalCptCodeType = value
          }
        }
      },
      preCptCodeType: {
        get() {
          return this.proReview.proRecordCpts[0]?.preCptCodeType || this.localPreCptCodeType
        },
        set(value) {
          if (this.proReview.proRecordCpts.length > 0) {
            this.proReview.proRecordCpts.forEach(cpt => {
              cpt.preCptCodeType = value
            })
          } else {
            this.localPreCptCodeType = value
          }
        }
      }
    }
  }
</script>

<style scoped>
  .dragIcon {
    cursor: move;
    margin: 1px 0px 0px 1px;
    padding: 0px 0px 0px 0px;
    float: left;
    height: 20px;
    color: #1f2d3d;
  }

  .drag-handle {
    cursor: move;
    display: block;
    float: left;
  }

  .cpt-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0;
  }

  /* enable horizontal scrolling on the table container */
  .hiaTable.level2 {
    overflow-x: auto;
  }

  .cpt-table .top-header {
    padding: 8px 8px 2px 8px;
    text-align: left;
    vertical-align: middle;
  }

  .cpt-table .bottom-header {
    padding: 2px 8px 8px 8px;
    text-align: left;
    vertical-align: top;
  }

  .cpt-table td {
    padding: 8px;
    padding-bottom: 40px;
    text-align: left;
    vertical-align: top;
    position: relative;
  }

  .cpt-table th {
    background-color: #f5f7fa;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
  }

  .cpt-table tbody tr:nth-child(even) {
    background-color: #fafafa;
  }

  .add-row {
    background-color: #fff !important;
    border-top: 1px solid #ebeef5;
  }

  .cpt-table tbody tr:hover {
    background-color: #f0f9ff;
  }

  .cpt-table tbody tr {
    border-top: 1px solid #e2e8f0;
  }

  .add-row-table {
    margin-top: 2px;
  }

  .add-row-table tbody tr {
    height: 40px;
    border-top: 1px solid #ebeef5;
    background-color: #fff !important;
  }

  .add-row th,
  .add-row td {
    vertical-align: middle;
  }

  .leftBorder {
    border-left: 2px solid #ebeef5 !important;
  }

  .lineSequenceCol {
    width: 17px;
  }

  .codeTypeCol {
    width: 130px;
  }

  .preActionsCol {
    width: 55px;
  }

  .actionsCol {
    max-width: 90px;
    min-width: 90px;
  }

  .reasonForChangeCol {
    min-width: 120px;
    max-width: 140px;
  }

  .deleteCol {
    max-width: 30px;
  }

  .addCol {
    min-width: 150px;
  }

  .thirtyPx {
    min-width: 20px;
  }

  .fiftyPx {
    width: 50px;
  }

  .seventyFivePx {
    width: 75px;
  }

  .oneHundredPx {
    width: 100px;
  }

  .twentyPercent {
    width: 20%;
  }

  .descOverflow {
    word-break: break-word;
  }

  .hiaTable .el-icon-close {
    border: 1px solid transparent;
  }

  .hiaTable tr:nth-child(even) .el-icon-close {
    border: 1px solid #606266;
    border-radius: 100%;
  }

  #cptGridAddRow thead {
    visibility: collapse;
  }

  #cptGridAddRow tbody > tr {
    height: 40px;
    border-top: 1px solid #ebeef5;
    background-color: #fff !important;
  }

  #cptGrid tr {
    vertical-align: top;
  }

  #cptGrid ::placeholder {
    opacity: 0.8;
  }

  .cpt-table thead tr {
    vertical-align: middle;
  }

  .cpt-table thead th {
    vertical-align: middle;
  }

  >>> .hcc {
    border-radius: 5%;
    color: DimGray;
    text-align: center;
    border: 1px solid DarkGray;
    font-size: 12px;
    padding: 0px 1px 0px 1px;
    margin: 0px 2px 0px 2px;
  }

  >>> .hcc28 {
    color: #005695;
    border-color: #005695;
    opacity: 0.8;
  }

  >>> .strikethrough {
    text-decoration: line-through;
  }

  >>> .feeScheduleHeader {
    color: #005695;
    border-top: 1px solid #ddd;
    /* border-top: 1px dashed #ddd; */
    margin-top: 2px;
    padding-top: 4px;
    font-weight: normal;
    font-size: 11px;
    width: 100%;
  }

  >>> .feeScheduleHeaderChild {
    margin: 0px 8px 8px 8px;
  }

  >>> .feeScheduleData {
    border-top: 1px solid #ddd;
    /* border-top: 1px dashed #ddd; */
    padding-top: 5px;
    padding-left: 4px;
    font-size: 11px;
    position: absolute;
    bottom: 8px;
    left: 8px;
    right: 8px;
    color: #005695;
    /* background-color: #ffffff; */
    border-radius: 2px;
    /* width: 100%; */
  }

  >>> #cptGrid.truCodeEnabled td {
    position: relative;
    padding-bottom: 32px;
  }

  .overflow {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 48px;
    text-overflow: ellipsis;
    cursor: zoom-in;
  }

  >>> .addMultiModifiers > .el-select__tags {
    overflow: hidden;
  }

  .headerWithBorder {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 5px;
    margin-bottom: 15px;
  }

  .modDialog {
    max-width: 90%;
  }

  .seventyFivePx {
    width: 75px;
  }

  .tenPercent {
    width: 13.5%;
  }

  .VuePagination__count {
    display: none;
  }

  .header-flex-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .subtle-add-icon {
    cursor: pointer;
    color: #606266; /* Darker gray */
    font-size: 14px;
    margin-left: 4px;
    margin-right: 6px;
    transition: color 0.2s;
    flex-shrink: 0;
  }

  .subtle-add-icon:hover {
    color: #409eff;
  }

  .context-menu {
    position: fixed;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 3000;
    min-width: 120px;
  }

  .context-menu-item {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
    transition: background-color 0.2s;
  }

  .context-menu-item:hover {
    background-color: #f5f7fa;
    color: #409eff;
  }

  .context-menu-item i {
    margin-right: 8px;
    font-size: 12px;
  }

  .delete-button {
    border: 1px solid transparent;
  }

  .cpt-row:nth-child(even) .delete-button {
    border: 1px solid #606266;
    border-radius: 100%;
  }

  .input-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .move-left-icon {
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    transition: color 0.2s;
    flex-shrink: 0;
  }

  .move-left-icon:hover {
    color: #409eff;
  }
</style>
